export function ModalOnPointerDownOutsideHandler(e: any) {
  const currentTarget = e.currentTarget as HTMLElement;
  if (e.detail.originalEvent.offsetX > currentTarget.clientWidth) {
    e.preventDefault();
  }
}
